import { audit, fastShip, generateShipBill, get, getByBillNumber, modify, pageQueryUnShipItem, query, queryQtyStrInfo, queryUnShipItems, queryVirtualUnShipItem, remove, save } from '@/services/forward/tms/ShipBill';
import { formatMessage } from 'umi/locale';

export default {
  namespace: 'shipbill',
  subscriptions: {
    /**
     * 监听浏览器地址
     * @param dispatch 触发器，用于触发 effects 中的 query 方法
     * @param history 浏览器历史记录，主要用到它的 location 属性以获取地址栏地址
     */
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location && location.pathname == "/tms/shipbill") {
          if (location.items) {
            let stores = [];
            let waveBillNumber = '';
            location.items.forEach(function (item) {
              stores.push(item.store);
            });
            waveBillNumber = location.waveBillNumber;

            dispatch({
              type: 'onGenerateShipBill',
              payload: {
                stores: stores,
                waveBillNumber: waveBillNumber,
              }
            })
            location.items = null;
          } else if (location.shipPlanBillNumber) {
            dispatch({
              type: 'showCreatePage',
              payload: {
                showPage: 'create',
                shipPlanBillNumber: location.shipPlanBillNumber,
                waveBillNumbers: location.waveBillNumbers
              }
            })
            location.shipPlanBillNumber = null;
            location.waveBillNumbers = null;
          } else if (location.payload) {
            dispatch({
              type: 'showPage',
              payload: location.payload,
            })
          }
        }
      });
    },
  },
  state: {
    data: {
      list: [],
      pagination: {},
    },
    entity: {},
    unShipItems: [],
    unShipContainerData: {
      list: [],
      pagination: {},
    },

    fromOrgData: {
      list: [],
      pagination: {},
    },

    storeData: {
      list: [],
      pagination: {},
    },
    showPage: 'query'
  },

  effects: {
    *query({ payload, callback }, { call, put }) {
      const response = yield call(query, payload);
      if (response.success) {
        yield put({
          type: 'save',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },

    *queryUnShipItems({ payload, callback }, { call, put }) {
      const response = yield call(queryUnShipItems, payload);
      yield put({
        type: 'saveWaitShipItem',
        payload: response.data
      });
      if (callback) callback(response);
    },

    *pageQueryUnShipItem({ payload, callback }, { call, put }) {
      const response = yield call(pageQueryUnShipItem, payload);
      if (response.success) {
        yield put({
          type: 'saveUnShipItemData',
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
    },

    *queryVirtualUnShipItem({ payload, callback }, { call, put }) {
      const response = yield call(queryVirtualUnShipItem, payload);
      const type = payload.queryType ? payload.queryType : 'saveUnShipItemData';
      if (response.success) {
        yield put({
          type: type,
          payload: {
            list: response.data.records ? response.data.records : [],
            pagination: {
              total: response.data.paging.recordCount,
              pageSize: response.data.paging.pageSize,
              current: response.data.page + 1,
              showTotal: response.data.paging.more ? undefined : total => formatMessage({ id: `共 {total} 条` }, { total: total }),
            },
          },
        });
      }
      if (callback) callback(response);
    },

    *get({ payload, callback }, { call, put }) {
      const response = yield call(get, payload);
      yield put({
        type: 'onView',
        payload: response.data
      });
      if (callback) callback(response);
    },

    *getByBillNumber({ payload, callback }, { call, put }) {
      const response = yield call(getByBillNumber, payload);
      yield put({
        type: 'onView',
        payload: response.data
      });
      if (callback) callback(response);
    },

    *onSave({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (response && response.success) {
        yield put({
          type: 'onShowPage',
          showPage: 'view',
          entityUuid: response.data
        });
      }
      if (callback) callback(response);
    },

    *onSaveAndCreate({ payload, callback }, { call, put }) {
      const response = yield call(save, payload);
      if (response && response.success) {
        yield put({
          type: 'onShowPage',
          showPage: 'create',
          entityUuid: undefined,
          entity: {}
        });
      }
      if (callback) callback(response);
    },

    *onModify({ payload, callback }, { call, put }) {
      const response = yield call(modify, payload);
      if (response && response.success) {
        yield put({
          type: 'onShowPage',
          showPage: 'view',
          entityUuid: payload.uuid
        });
      }
      if (callback) callback(response);
    },

    *onAudit({ payload, callback }, { call, put }) {
      const response = yield call(audit, payload);
      if (callback) callback(response);
    },

    *onRemove({ payload, callback }, { call, put }) {
      const response = yield call(remove, payload);
      if (callback) callback(response);
    },

    *onGenerateShipBill({ payload, callback }, { call, put }) {
      const response = yield call(generateShipBill, payload);
      if (response && response.success) {
        if (response.data && response.data != null) {
          yield put({
            type: 'onShowPage',
            showPage: 'view',
            entityUuid: response.data
          })
        } else {
          yield put({
            type: 'onShowPage',
            showPage: 'query',
          })
          // yield put({
          //   type: 'query',
          //   payload: {
          //     page: 0,
          //     pageSize: sessionStorage.getItem("searchPageLine") ?
          //       parseInt(sessionStorage.getItem("searchPageLine")) : 50,
          //     sortFields: { billNumber: true },
          //     searchKeyValues: {
          //       companyUuid: loginCompany().uuid,
          //       carrierUuid: (orgType.carrier.name === loginOrg().type) ?
          //         loginOrg().uuid : null,
          //       dcUuid: (orgType.carrier.name === loginOrg().type) ?
          //         null : loginOrg().uuid
          //     },
          //   }
          // });
        }
      } else {
        yield put({
          type: 'onShowPage',
          showPage: 'query',
        })
      }
      if (callback) callback(response);
    },

    *showPage({ payload }, { call, put }) {
      yield put({
        type: 'onShowPage',
        showPage: payload.showPage,
        entityUuid: payload.entityUuid,
        billNumber: payload.billNumber
      });
    },

    *onFastShip({ payload, callback }, { call, put }) {
      const response = yield call(fastShip, payload);
      if (response && response.success) {
        yield put({
          type: 'onShowPage',
          showPage: 'view',
          entityUuid: response.data
        });
      }
      if (callback) callback(response);
    },

    *onQueryQtyStrInfo({ payload, callback }, { call, put }) {
      const response = yield call(queryQtyStrInfo, payload);
      if (callback) callback(response);
    },

  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    saveWaitShipItem(state, action) {
      return {
        ...state,
        unShipItems: action.payload,
      };
    },
    saveUnShipItemData(state, action) {
      return {
        ...state,
        unShipContainerData: action.payload,
      };
    },
    onView(state, action) {
      return {
        ...state,
        entity: action.payload,
        entityUuid: action.entityUuid,
        billNumber: action.billNumber
      }
    },
    onShowPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        entityUuid: action.entityUuid,
        billNumber: action.billNumber,
        entity: {},
        shipPlanBillNumber: undefined,
        waveBillNumbers: undefined,
      }
    },
    showCreatePage(state, action) {
      return {
        ...state,
        entityUuid: undefined,
        entity: action.payload.entity,
        showPage: action.payload.showPage,
        shipPlanBillNumber: action.payload.shipPlanBillNumber,
        waveBillNumbers: action.payload.waveBillNumbers
      }
    },
    queryStore(state, action) {
      return {
        ...state,
        storeData: action.payload
      };
    }
  },
}
